import React from 'react';

import { useTranslation } from 'react-i18next';

import useBodyOverflowToggle from 'components/hooks/useBodyOverflowToggle';
import useEscapeKey from 'components/hooks/useEscapeKey';

import TextButton from 'components/application/buttons/TextButton';

export default function UnsavedChangesModal({
  actionButton,
  body,
  header,
  isOpen,
  onClose,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  useBodyOverflowToggle(isOpen);
  useEscapeKey(onClose, [isOpen]);

  return (
    <div
      className={`unsaved-changes-modal unsaved-changes-modal--${isOpen ? 'open' : 'close'}`}
    >
      <div className='modalbox__scroller'>
        <div className='popup__backdrop tw-bg-grey-900 tw-opacity-75' />
        <div className='unsaved-changes-modal__wrapper'>
          <div className='unsaved-changes-modal__content tw-bg-white'>
            <div className='unsaved-changes-modal__header tw-text-l tw-font-semibold tw-text-grey-900'>
              {header}
            </div>
            <div className='unsaved-changes-modal__body tw-border-grey-100'>
              {body}
            </div>
            <div className='unsaved-changes-modal__footer tw-border-grey-100'>
              <TextButton
                className='unsaved-changes-modal--cancel-button tw-mr-3'
                color='blue'
                onClick={onClose}
                size='md'
              >
                {i18nTShared('cancel')}
              </TextButton>
              {actionButton}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
